import { createSelector } from '@reduxjs/toolkit';

export const selectTestCases = (state) => state.testCases.testCases;
export const selectTestCasesCount = (state) => state.testCases.testCasesCount;
export const selectAllTestCases = createSelector([(state) => state.testCases?.allTestCases ?? []], (items) => items);

export const selectTestCaseHistory = (state) => state.testCases.testCaseHistory;

export const selectTestCaseSelectedRevision = (state) => state.testCases.testCaseSelectedRevision;

export const selectTestCaseDataActual = (state) => state.testCases.testCase;
export const selectTestCaseDataLocal = (state) => state.testCases.testCaseLocal;
export const selectCreatedTestCaseId = (state) => state.testCases.createdTestcaseId;
export const selectTestCaseResults = (state) => state.testCases.testCaseResults;
export const selectTestCaseResultsTotalCount = (state) => state.testCases.testCaseResultsCount;
export const selectGetTestCaseResultsStatus = (state) => state.testCases.getTestCaseResultsStatus;
export const selectGetTestCaseResultsErrorInfo = (state) => state.testCases.getTestCaseResultsError;

export const selectAddTestCaseStatus = (state) => state.testCases?.addStatus;

export const selectGetTestCasesStatus = (state) => state.testCases.getTestCasesStatus;
export const selectGetAllTestCasesStatus = (state) => state.testCases.getAllTestCasesStatus;

export const selectGetTestCaseHistoryStatus = (state) => state.testCases.getTestCaseHistoryStatus;
export const selectGetTestCaseCertainRevisionStatus = (state) => state.testCases.getTestCaseCertainRevisionStatus;

export const selectGetTestCaseStatus = (state) => state.testCases.getTestCaseByIdStatus;

export const selectEditTestCaseStatus = (state) => state.testCases.editStatus;

export const selectDeleteTestCaseStatus = (state) => state.testCases?.deleteStatus;

export const selectAddTestCaseErrorInfo = (state) => state.testCases.addError;

export const selectGetTestCasesErrorInfo = (state) => state.testCases.getTestCasesError;

export const selectGetTestCaseHistoryErrorInfo = (state) => state.testCases.getTestCaseHistoryError;

export const selectGetTestCaseErrorInfo = (state) => state.testCases.getTestCaseByIdError;

export const selectEditTestCaseErrorInfo = (state) => state.testCases.editError;

export const selectDeleteTestCaseErrorInfo = (state) => state.testCases.deleteError;

export const selectTestcasesFromAddDialog = (state) => state.testCases.testCasesFromAddDialog;

export const selectDuplicateTestCaseStatus = (state) => state.testCases.duplicateStatus;
